import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCakehomeCustomerList as _getCakehomeCustomerList, getCakehomeMoneyTypes as _getCakehomeMoneyTypes, getEditCakehomeRule, getEditCakehomeRuleCustom as _getEditCakehomeRuleCustom, handChannelWarningRestrictions } from '@/api/goodsCenter';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      customRadio: 1,
      goodsRadio: -1,
      activeName: 'custom',
      customForm: {
        id: '',
        name: '',
        page: 1,
        page_size: 20
      },
      cinemaForm: {
        cinema_name: '',
        standard_id: '',
        page: 1,
        pagesize: 20
      },
      // 列表查询参数
      setFormRule: {
        rule_name: '',
        adjust_type: ['1'],
        selected_goods_ids: -1,
        // 商品范围全部目前写死的
        money_type: '1',
        by_ratio_adjust: '',
        by_money_adjust: '',
        is_show_line_price: '0',
        line_price_field: '1'
      },
      selected_standard_ids: [],
      tableKey: 0,
      pages: {},
      totalCount: null,
      customList: [],
      checkedCustom: [],
      checkedDelCustom: [],
      checkedCustomList: [],
      rule_id: '',
      // 有值为编辑 没值则为添加
      ruleType: '',
      moneyTypes: [],
      warning_restrictions: 0,
      // 折扣预警值
      line_price_field_type: []
    };
  },
  computed: {
    priceType: function priceType() {
      if (this.setFormRule.adjust_type.length == 2) {
        return 'all';
      } else if (this.setFormRule.adjust_type.length) {
        if (this.setFormRule.adjust_type[0] == 1) {
          return 'ratio';
        } else {
          return 'money';
        }
      } else {
        return '';
      }
    }
  },
  created: function created() {
    var _ids;
    var ids = this.$route.query.ids;
    if (typeof ids === 'string') {
      ids = [ids];
    }
    this.selected_standard_ids = (_ids = ids) !== null && _ids !== void 0 && _ids.length ? ids : '';
    this.getChannelWarningRestrictions();
  },
  methods: {
    // 获取折扣预警
    getChannelWarningRestrictions: function getChannelWarningRestrictions() {
      var _this = this;
      handChannelWarningRestrictions().then(function (res) {
        _this.warning_restrictions = Number(res.data.warning_restrictions);
      });
    },
    // 添加调价规则
    getList: function getList() {
      var _this2 = this;
      // 客户列表
      this.getCakehomeCustomerList();
      // 调价基数
      this.getCakehomeMoneyTypes();
      this.$nextTick(function () {
        _this2.dialogVisible = true;
      });
    },
    // 编辑调价规则
    getEditInfo: function getEditInfo() {
      var _this3 = this;
      this.getCakehomeMoneyTypes();
      this.getCakehomeCustomerList();
      this.getEditCakehomeRuleCustom();
      // 编辑获取设置影院规则数据
      getEditCakehomeRule({
        rule_id: this.rule_id
      }).then(function (res) {
        _this3.setFormRule = res.data.data;
        _this3.dialogVisible = true;
      });
    },
    // 编辑获取已选客户
    getEditCakehomeRuleCustom: function getEditCakehomeRuleCustom() {
      var _this4 = this;
      _getEditCakehomeRuleCustom({
        rule_id: this.rule_id,
        pagesize: 10000
      }).then(function (res) {
        _this4.checkedCustomList = res.data.data.data;
      });
    },
    getCakehomeMoneyTypes: function getCakehomeMoneyTypes() {
      var _this5 = this;
      _getCakehomeMoneyTypes().then(function (res) {
        _this5.moneyTypes = res.data.data;
        _this5.line_price_field_type = res.data.line_price_types;
      });
    },
    // 获取客户列表
    getCakehomeCustomerList: function getCakehomeCustomerList() {
      var _this6 = this;
      _getCakehomeCustomerList(this.customForm).then(function (res) {
        _this6.customList = res.data.list;
        _this6.pages = res.pages;
      });
    },
    // 设置规则弹框 待选择客户table 选中事件
    handleSelectionCustom: function handleSelectionCustom(val, type) {
      if (type == 'custom') {
        this.checkedCustom = val;
      } else {
        this.checkedCinema = val;
      }
    },
    // 设置规则弹框 已选择客户table选中事件
    handleCheckedDelCustom: function handleCheckedDelCustom(val, type) {
      if (type == 'custom') {
        this.checkedDelCustom = val;
      }
    },
    // 搜索设置规则里的查询客户
    searchCustom: function searchCustom(type) {
      if (type == 'custom') {
        this.customForm.page = 1;
        this.getCakehomeCustomerList();
      }
    },
    // 设置规则 批量添加客户
    batchAddCustom: function batchAddCustom(type) {
      if (type == 'custom') {
        var _this$checkedCustomLi;
        if (!this.checkedCustom.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        (_this$checkedCustomLi = this.checkedCustomList).push.apply(_this$checkedCustomLi, _toConsumableArray(this.checkedCustom));
        this.$refs.multipleTable.clearSelection();
      } else {
        this.tableKey++;
        if (!this.checkedCinema.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 批量删除客户
    batchDel: function batchDel(type) {
      var _this7 = this;
      if (type == 'custom') {
        this.checkedDelCustom.forEach(function (item) {
          var index = _this7.checkedCustomList.indexOf(item);
          if (index !== -1) {
            _this7.checkedCustomList.splice(index, 1);
          }
        });
      }
    },
    // 待选择客户的禁用选项框条件
    selectableCustom: function selectableCustom(row) {
      var flag = true;
      this.checkedCustomList.forEach(function (e) {
        if (e.id == row.id) {
          flag = false;
        }
      });
      return flag;
    },
    submitAdjustRule: function submitAdjustRule() {
      var _this8 = this;
      this.$refs.setFormRule.validate(function (valid) {
        if (valid) {
          _this8.$confirm('为防止规则冲突，本公司用户不允许绑其他公司卡，不允许纯微信支付；系统自动完成相关开关的设置！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(function () {
            var params = _objectSpread(_objectSpread({}, _this8.setFormRule), {}, {
              selected_goods_ids: -1,
              selected_company_info: _this8.customRadio == 1 ? _this8.checkedCustomList.map(function (i) {
                return {
                  company_name: i.company_name,
                  id: i.id
                };
              }) : '-1',
              type: _this8.ruleType == 'add' ? 'add' : 'edit'
            });
            if (!_this8.checkedCustomList.length && _this8.customRadio == 1) {
              params.selected_company_info = '';
            }
            if (_this8.customRadio == -1 && _this8.goodsRadio == -1) {
              _this8.$message.info('已存在全局规则，无法选择全部商品和全部客户');
              return false;
            }
            _this8.$emit('emitSubmit', params);
          }).catch(function () {});
        }
      });
    },
    // 分页操作
    onChange: function onChange(val, type) {
      if (type == 'custom') {
        this.customForm.page = val;
        this.getCakehomeCustomerList();
      }
    },
    sizeChange: function sizeChange(val, type) {
      // this.form.pagesize = val
      if (type == 'custom') {
        this.customForm.page_size = val;
        this.getCakehomeCustomerList();
      }
    },
    closeDialog: function closeDialog() {
      this.setFormRule = {
        rule_name: '',
        adjust_type: ['1'],
        by_ratio_adjust: '',
        by_money_adjust: '',
        money_type: '1',
        is_show_line_price: '0',
        line_price_field: '1'
      };
      this.customRadio = 1;
      this.goodsRadio = -1;
      this.activeName = 'custom';
      this.customForm = {
        name: '',
        id: ''
      };
      this.ruleType = '';
      this.$refs.setFormRule.resetFields();
      this.checkedCustomList = [];
    }
  }
};